<template>
  <div>
    <form role="form" name="myForm" @submit.prevent="ChangePassword" novalidate>
      <div class="box" style="margin-top:150px;width:520px;">
        <header class="head">
          <div align="center">
            <img style="margin-top:-80px;" src="../../assets/imgs/logo.png" />
          </div>
          <h1>Change Your Password</h1>
        </header>
        <div v-if="successMessage != ''" class="alert alert-success text-center">
          <strong>{{successMessage}}</strong>
        </div>

        <input
          type="password"
          class="password"
          :class="{'input-validation-error':OldPasswordFlags.invalid &&(!OldPasswordFlags.pristine)}"
          name="OldPassword"
          placeholder="Old Password"
          style="margin-left:30px;"
          v-model="OldPassword"
          autocomplete="off"
          data-vv-as="Old Password"
          v-validate="'required'"
        />
        <span
          class="text-danger"
          style="margin-left:30px;padding:10px"
          v-if="errors.first('OldPassword')"
        >{{errors.first('OldPassword')}}</span>
        <input
          type="password"
          class="resetpassword-password"
          :class="{'input-validation-error': ((PasswordFlags.invalid && !PasswordFlags.pristine)||errors.has('Password'))}"
          name="Password"
          placeholder="New Password"
          autocomplete="off"
          v-model="Password"
          style="margin-left:30px;"
          ref="pass"
          v-validate="'required|strong_password'"
          data-vv-validate-on="blur"
        />

        <p
          class="text-danger"
          style="margin-left:30px;padding:10px"
          v-if="errors.first('Password')"
        >{{errors.first('Password')}}</p>
        <input
          type="password"
          class="resetpassword-password"
          v-validate="'required|confirmed:pass'"
          autocomplete="off"
          :class="{'input-validation-error': ((ConfirmPasswordFlags.invalid && !ConfirmPasswordFlags.pristine)||errors.has('ConfirmPassword'))}"
          name="ConfirmPassword"
          placeholder="Confirm Password"
          data-vv-validate-on="blur"
          v-model="ConfirmPassword"
          style="margin-left:30px;"
          data-vv-as="Confirm Password"
          required
        />

        <span
          class="text-danger"
          v-if="errors.first('ConfirmPassword')"
          style="margin-left:30px; margin-right:20px; "
        >{{errors.first('ConfirmPassword')}}</span>
        <!-- <input
          type="text"
          class="resetpassword-email"
          :class="{'input-validation-error':OTPFlags.invalid &&(!OTPFlags.pristine)}"
          name="OTP"
          autocomplete="off"
          placeholder="OTP"
          style="margin-left:30px;"
          v-model="OTP"
          v-validate="'required'"
          autofocus
        />-->
        <!-- <span
          class="text-danger"
          style="margin-left:30px;"
          v-if="errors.first('OTP')"
        >{{errors.first('OTP')}}</span>-->

        <div class="row" style="margin-top:10px;">
          <div class="col-md-8" style="margin-left:30px;">
            <loading v-if="loading"></loading>
            <input
              type="submit"
              class="login-button"
              value="Change Password"
              style="margin-left:5px;"
            />
            <input
              type="button"
              class="login-button"
              style="margin-left:10px;"
              @click="GoBack"
              value="Back"
            />
            <!--	<input type="button" class="reset"  value="reset" /> -->
          </div>
        </div>
        <br />
        <div
          v-if="errorMessage != '' &&  errorMessage !=null"
          class="alert alert-danger text-center"
        >
          <strong>{{errorMessage}}</strong>
        </div>
        <div v-if="expiredLinkMessage != ''" class="alert alert-danger text-center">
          <strong>{{expiredLinkMessage}}</strong>
        </div>
        <br />
      </div>
    </form>
  </div>
</template>


<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vee-validate";
export default {
  data() {
    return {
      Password: "",
      expiredLinkMessage: "",
      OldPassword: "",
      ConfirmPassword: "",
      //loading:true,
      successMessage: "",
      Token: "",
      OTP: ""
    };
  },
  methods: {
    GoBack() {
      this.$router.push("/Login");
    },
    ChangePassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var vm = this;
          var _token = this.Token;
          var params = new URLSearchParams();
          params.append("OldPassword", this.OldPassword);
          params.append("Password", this.Password);
          params.append("ConfirmPassword", this.ConfirmPassword);
          params.append("Token", _token);
          // params.append("OTP", this.OTP);

          this.$store
            .dispatch(ACTIONS.CHANGE_PASSWORD, params)
            .then(res => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.successMessage = "Password Changed Successfully.";
                var redirect = this.$route.query.redirect;
                setTimeout(() => {
                  vm.successMessage = null;
                  if (redirect) {
                    vm.$router.push(redirect);
                  } else {
                    vm.$router.push("/");
                  }
                }, 1800);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop]
                    });
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          this.error = " Please Provide correct details";
          var vm = this;
          setTimeout(() => {
            vm.error = "";
          }, 2200);
        }
      });
    },

    checkResetLinkValidity() {
      //var tolen = this.Token;
      var query = "?token=" + this.Token;
      var vm = this;
      this.$store
        .dispatch(ACTIONS.CHECK_LINK_AVAILABLE, query)
        .then(res => {
          var { data } = res;

          if (data && data.StatusCode == 200) {
            vm.expiredLinkMessage = data.StatusMessage;
          } else {
            vm.expiredLinkMessage = "";
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeMount() {
    if (this.$route.params.key != null || this.$route.params.key != "") {
      this.Token = this.$route.params.key;
      this.checkResetLinkValidity();
    }
  },
  computed: {
    ...mapGetters({
      loading: "GETRESETLOADING",
      errorMessage: "GETRESETERRORMESSAGE",
      UserId: "GETRESETPASSWORDUSERID"
    }),
    ...mapFields({
      UsernameFlags: "Username",
      PasswordFlags: "Password",
      ConfirmPasswordFlags: "ConfirmPassword",
      OldPasswordFlags: "OldPassword"
      // OTPFlags: "OTP"
    })
  }
};
</script>